var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2389_71535)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00012 2.34375C6.98083 2.34375 5.34387 3.98071 5.34387 6C5.34387 7.09415 5.82449 8.07606 6.58612 8.74611C4.55603 9.44573 2.92595 11.0031 2.12797 12.9839L1.90039 13.5488L2.44678 13.8179C4.33175 14.746 6.58627 15.2812 9.00017 15.2812C11.4141 15.2812 13.6686 14.746 15.5536 13.8178L16.1 13.5488L15.8724 12.9839C15.0744 11.003 13.4443 9.44566 11.4142 8.74606C12.1758 8.07601 12.6564 7.09413 12.6564 6C12.6564 3.98071 11.0194 2.34375 9.00012 2.34375ZM6.65637 6C6.65637 4.70558 7.7057 3.65625 9.00012 3.65625C10.2945 3.65625 11.3439 4.70558 11.3439 6C11.3439 7.29442 10.2945 8.34375 9.00012 8.34375C7.7057 8.34375 6.65637 7.29442 6.65637 6ZM9.00017 13.9688C7.02562 13.9688 5.18379 13.5795 3.60853 12.9074C4.63049 10.9731 6.66223 9.65625 9.00021 9.65625C11.3382 9.65625 13.3699 10.9731 14.3919 12.9074C12.8166 13.5795 10.9747 13.9688 9.00017 13.9688Z",
    fill: "#6C7794"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 3.5,
    r: 4.375,
    fill: "#FF553E",
    stroke: "#192337",
    strokeWidth: 1.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2389_71535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonDot);
export default __webpack_public_path__ + "static/media/person-dot.b60654513cca9bba704725b66d12ffd6.svg";
export { ForwardRef as ReactComponent };